import {
  Button,
  Col,
  DatePicker,
  Form,
  GetProp,
  Input,
  InputNumber,
  Radio,
  Row,
  Select,
  Upload,
  UploadFile,
  UploadProps,
  Image,
  Modal,
  Checkbox,
  Switch,
} from "antd";
import { TABS } from "./EditPatientInfo";
import {
  GenderType,
  GkboxType,
  Patient,
  StrongHandType,
  PoliType,
} from "./interfaces";
import React, { useEffect, useRef, useState } from "react";
import itIT from "antd/lib/locale/it_IT";
import Tesseract from 'tesseract.js';
import "moment/locale/it";
import TextArea from "antd/lib/input/TextArea";
import moment from "moment";
import { AlertOutlined, CheckOutlined, CopyOutlined, PlusOutlined, SendOutlined } from "@ant-design/icons";
import "../App.css";
import { RcFile } from "antd/es/upload";
import { deleteFile, getUploadedFile, uploadFile } from "./utils";
import { SignedInDoctor } from "../auth/interfaces";
import { UploadFileStatus } from "antd/lib/upload/interface";
import { editStudio } from "../studio/utils";
import CodiceFiscale from 'codice-fiscale-js';
const { Option } = Select;

//codicefiscale generator LEOB

// API KEY OPENAI - lettura da variabili d'ambiente
const API_KEY = process.env.REACT_APP_API_KEY || '';

// Required edit patient form items tab
const EditPatientFormItemsRequired = ({
  patient,
  setPatient,
  signedInDoctor,
}: {
  patient: Patient;
  setPatient: Function;
  signedInDoctor: SignedInDoctor;
  
}) => {
  type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];


  const getBase64 = (file: FileType): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

  const [previewOpen, setPreviewOpen] = useState(false);
  const [copyOk, setCopyOk] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [fileList, setFileList] = useState<UploadFileExtend[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
 
  

  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button">
      <PlusOutlined rev={undefined} />
      <div style={{ marginTop: 8, fontWeight: "bold", color: "grey" }}> Foto <br/> Profilo </div>
    </button>
  );


  useEffect(() => {
    if (patient && patient.patientFiles && patient.patientFiles.length > 0) {
      for (const patientFile of patient.patientFiles) {
        getUploadedFile(patient.id || -1, patientFile.fileName, signedInDoctor)
          .then(retrievedFile => {
            if (retrievedFile != undefined && retrievedFile.length == 2 && retrievedFile[0].length > 0)
              setFileList(prevFileList => [...prevFileList,
              {
                uid: generateCryptoUid(), status: 'done' as UploadFileStatus, name: patientFile.fileName,
                url: retrievedFile[0], type: retrievedFile[1],
                ...patientFile
              }])
          })
          .catch(err => console.error("Error while attempting to download img " + patientFile.fileName + " for patient " + (patient.id || -1), err))
      }
    }
  }, []);

  const handlePreview1 = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as FileType);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };

  const handleChange1: UploadProps['onChange'] =
    ({ fileList: newFileList }) => {
      for (let f2 of fileList) {
        if (f2.fileId && f2.status && f2.status == "removed") {
          deleteFile(f2.fileId, f2.name, signedInDoctor, patient.id || -1);
        }
      }
      setFileList(newFileList);
      setPatient((prevPatient: Patient) => ({ ...prevPatient, patientFiles: newFileList }))
    }

    const uploadAction1 = async (uploadObjWrapper: any) => {
      return new Promise((resolve, reject) => {
        if (patient.id && uploadObjWrapper.file && uploadObjWrapper.file instanceof File) {
          const file: File = uploadObjWrapper.file;
          uploadFile(file, generateCryptoUid() + "profile_image" + file.name, signedInDoctor, patient.id ? patient.id : -1)
            .then(res => {
              if (res.fileName && res.fileId > 0) {
                for (let fileobj of fileList) {
                  if (fileobj.name && res.fileName.indexOf(fileobj.name) > 0) {
                    const newFileList = fileList.map((x) => (x.uid != fileobj.uid) ? x : {
                      ...x, status: 'done' as UploadFileStatus, fileId: res.fileId,
                      fileName: res.fileName, name: res.fileName, url: fileobj.url
                    })
                    setFileList(newFileList)
                    setPatient((prevPatient: Patient) => ({ ...prevPatient, patientFiles: newFileList }))
                  }
                }
                resolve(res)
              }
              else
                reject(false)
            })
            .catch(err => console.log(err))
        }
        else
          reject(false)
      })
    }
  


  return (
    <>
<Row  style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>

  <Col span={window.innerWidth < 786 ? 24 : 4} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', zoom: window.innerWidth < 1100 ? 1.5 : 2.6 }}>
      <Upload
        customRequest={uploadAction1}
        listType="picture-circle"
        fileList={fileList.filter(file => file.name.includes("profile_image"))}
        onPreview={handlePreview1}
        onChange={handleChange1}
        accept="image/png, image/jpeg, image/heic, image/heif, image/gif, application/pdf"
        showUploadList={{ showDownloadIcon: true, showPreviewIcon: true, showRemoveIcon: true }}
        itemRender={(originNode, file) => {
          return (
            <>
              <div style={{
                width: 100,
                height: 100,
                borderRadius: '50%',
              }}>
                {originNode}
              </div>
            </>
          )
        }}
      >
         {fileList.filter(file => file.name.includes("profile_image")).length === 0 && (
          <>
        {uploadButton}
        </>
      )}
      </Upload>

    {previewImage && (
      <>
        <Image
          style={{ marginBottom: '100px' }}
          wrapperStyle={{ display: 'none' }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(''),
          }}
          src={previewImage}
        />
      </>
    )}
    </Col>
  
 
    <Col span={20}>
    <Row style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
 
      <Col span={9}>
        <Form.Item name="name" label="Nome" rules={[{ required: true }]}>
          <Input
            placeholder="Nome"
            required
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPatient({ ...patient, name: e.target.value })
            }
            value={patient.name}
          />
        </Form.Item>
      </Col>
      <Col span={1}></Col>
      <Col span={10}>
        <Form.Item name="surname" label="Cognome" rules={[{ required: true }]}>
          <Input
            placeholder="Cognome"
            required
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPatient({ ...patient, surname: e.target.value })
            }
          />
        </Form.Item>
      </Col>
 
      <Col span={8}>
        <Form.Item name="gender" label="Genere" rules={[{ required: true }]}>
          <Select
            placeholder="Seleziona un'opzione"
            onChange={(selected: number) =>
              setPatient({ ...patient, gender: selected })
            }
          >
            <Option value={GenderType.M}>Maschio</Option>
            <Option value={GenderType.F}>Femmina</Option>
            <Option value={GenderType.O}>Altro</Option>
          </Select>
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item
          name="telephoneD"
          label="Telefono"
          rules={[{ required: true }]}
        >
          <Input
            placeholder="Contatto telefonico"
            required
            addonBefore={"+39"}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPatient({
                ...patient,
                telephone: "+39" + e.target.value,
              })
            }
          />
        </Form.Item>
      </Col>
      </Row>
      </Col>  
      
    </Row>
   
  </>
);

};



const cfGenerator = (patient: Patient, setPatient: Function) => {
 
  const cf = CodiceFiscale.compute({
    name: patient.name,
    surname: patient.surname,
    gender: patient.gender === GenderType.M ? 'M' : 'F',
    birthday: patient.birthDate,
    birthplace: patient.birthCity,
  });
  setPatient({ ...patient, cf });
  
  
 
};




// Advanced edit patient form items tab
const EditPatientFormItemsAdvanced = ({
  patient,
  setPatient,
}: {
  patient: Patient;
  setPatient: Function;
}) => (


  <>
    <Row>
      <Col span={10}>
        <Form.Item name="street" label="Indirizzo">
          <Input
            placeholder="Via"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPatient({ ...patient, street: e.target.value })
            }
          />
        </Form.Item>
      </Col>
      <Col span={1} />
      <Col span={2}>
        <Form.Item name="streetNumber" label="Civico">
          <Input
            placeholder="N° civico"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPatient({ ...patient, streetNumber: e.target.value })
            }
          />
        </Form.Item>
      </Col>
    </Row>

    <Row>
      <Col span={10}>
        <Form.Item name="city" label="Comune di residenza">
          <Input
            placeholder="Comune di residenza"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPatient({ ...patient, city: e.target.value })
            }
          />
        </Form.Item>
      </Col>

      <Col span={1} />
      <Col span={4}>
        <Form.Item name="cap" label="CAP">
          <Input
            placeholder="CAP"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPatient({ ...patient, cap: e.target.value })
            }
          />
        </Form.Item>
      </Col>
      <Col span={1} />
      <Col span={4}>
        <Form.Item name="province" label="Provincia">
          <Input
            placeholder="Provincia"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPatient({ ...patient, province: e.target.value })
            }
          />
        </Form.Item>
      </Col>
    </Row>
    <Row>
      <Col span={7}>
      <Input
            placeholder="Codice fiscale"
            value={patient.cf}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPatient({ ...patient, cf: e.target.value })
            }
          />
            </Col>
      <Col className="col-gcod" span={1}>
        <Button title="Genera Codice Fiscale" className="ant-title-content" onClick={() => {cfGenerator(patient, setPatient)}} >
          <AlertOutlined rev={undefined} />
        </Button>
      </Col>
      <Col span={1}></Col>
      <Col span={3}>
        <Form.Item label="Data di nascita">
          <DatePicker
            locale={itIT.DatePicker}
            format={"DD/MM/YYYY"}
            onChange={(date) =>
              setPatient({ ...patient, birthDate: date })
            }
            defaultValue={
              patient.birthDate ? moment(patient.birthDate) : undefined
            }
          />
        </Form.Item>
      </Col>
      <Col span={12}>
        <Form.Item name="birthCity" label="Luogo di nascita">
          <Input
            placeholder="Città"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPatient({
                ...patient,
                birthCity: e.target.value,
              })
            }
          />
        </Form.Item>
      </Col>
    </Row>
    <Row>
      <Col span={8}>
        <Form.Item name="email" label="Email">
          <Input
            type={"email"}
            placeholder="email"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPatient({ ...patient, email: e.target.value })
            }
          />
        </Form.Item>
      
     

      </Col>
      <Col span={1} />
      <Col span={4}>
      
        <Form.Item name="privacy" valuePropName="checked">
          <Switch
            checked={patient.privacy}
            onChange={(checked) => {
              
              setPatient({ ...patient, privacy: checked });
            }}
          /> Consenso e Privacy
        </Form.Item>
     

      </Col>
      <Col span={1} />
      
      <Col span={4}>
      
      <Form.Item name="elicoidali" valuePropName="checked">
        <Switch
          checked={patient.elicoidali}
          onChange={(checked) => {
            
            setPatient({ ...patient, elicoidali: checked });
          }}
        /> Elicoidali
      </Form.Item>
   

    </Col>
    <Col span={1} />
      
      <Col span={4}>
      
      <Form.Item name="solette" valuePropName="checked">
        <Switch
          checked={patient.solette}
          onChange={(checked) => {
            
            setPatient({ ...patient, solette: checked });
          }}
        /> Solette/Plantari
      </Form.Item>
   

    </Col>

     
    </Row>
  </>

);
 
/*    <Col span={1}></Col>
      <Col span={5} style={{ display: 'flex', alignItems: 'flex-end' }}>
        <Checkbox>Consenso dell'utilizzo dati.</Checkbox> 
        </Col>
*/ 


// Medical info edit patient form items tab
const EditPatientFormItemsMedical = ({
  patient,
  setPatient,
}: {
  patient: Patient;
  setPatient: Function;
}) => (
  <>
    <Row>
      <Col span={8}>
        <Form.Item name="physician" label="Medico di base">
          <Input
            placeholder="medico"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPatient({ ...patient, physician: e.target.value })
            }
          />
        </Form.Item>
      </Col>
      <Col span={1}></Col>
      <Col span={8}>
        <Form.Item name="allergies" label="Allergie">
          <Input
            placeholder="allergie"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPatient({ ...patient, allergies: e.target.value })
            }
          />
        </Form.Item>
      </Col>
      <Col span={1}></Col>
    </Row>
    <Row className="centered">
      <Col span={3}>
        <Form.Item name="height" label="Altezza (cm)">
          <InputNumber
            placeholder="Altezza"
            className="border"
            min="0"
            max="250"
            step="0.5"
            onChange={(value) => setPatient({ ...patient, height: value })}
          />
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item name="weight" label="Peso (kg)">
          <InputNumber
            placeholder="Peso"
            className="border"
            min="0"
            max="450"
            step="0.5"
            onChange={(value) => setPatient({ ...patient, weight: value })}
          />
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item name="footSize" label="Piede (EU)">
          <InputNumber
            placeholder="Piede (EU)"
            className="border"
            min="32"
            max="50"
            step="0.5"
            onChange={(value) => setPatient({ ...patient, footSize: value })}
          />
        </Form.Item>
      </Col>
      <Col span={8}>
        <Form.Item name="strongHand" label="Mano Forte">
          <Radio.Group
            onChange={(e) =>
              setPatient({ ...patient, strongHand: e.target.value })
            }
          >
            <Radio.Button value={StrongHandType.SX}>Sx</Radio.Button>
            <Radio.Button value={StrongHandType.SX_DX}>Ambidestro</Radio.Button>
            <Radio.Button checked value={StrongHandType.DX}>
              Destro
            </Radio.Button>
          </Radio.Group>
        </Form.Item>
      </Col>
    </Row>
    <Row>
    
      <Col span={0}></Col>
      <Col span={24}>
        <Form.Item
          name="preexistingConditions"
          label="Condizioni pre-esistenti"
        >
       
          <TextArea
            placeholder="Condizioni pre-esistenti"
            showCount
            maxLength={1024}
            style={{ padding: 10, height: 160, borderRadius: 25 }}
            onChange={(e) =>
              setPatient({
                ...patient,
                preexistingConditions: e.target.value,
              })
            }
            count={undefined}
          />
        </Form.Item>
      </Col>
    </Row>
  </>
);

interface UploadFileExtend extends UploadFile
{
  fileId?: number;
  description?: string;
  createdAt?: Date;
  updatedAt?: Date;
  error?: string;
}

function generateCryptoUid() {
  return crypto.getRandomValues(new Uint8Array(16))
    .reduce((uid, byte) => uid + byte.toString(16).padStart(2, '0'), '');
}



// Form per vedere e caricare documenti
const EditPatientFormItemsDocument = ({
  patient,
  setPatient,
  signedInDoctor
}: {
  patient: Patient;
  setPatient: Function;
  signedInDoctor: SignedInDoctor;
}) => {
  type FileType = Parameters<GetProp<UploadProps, 'beforeUpload'>>[0];

  const getBase64 = (file: FileType): Promise<string> =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });

    const [analitycsVisible, setAnalitycsVisible] = useState(false);
    const [previewOpen, setPreviewOpen] = useState(false);
  
  const [copyOk, setCopyOk] = useState(false);
  const [previewImage, setPreviewImage] = useState('');
  const [fileList, setFileList] = useState<UploadFileExtend[]>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [extractedText, setExtractedText] = useState('');
  const [additionalNotes, setAdditionalNotes] = useState(
    patient.additionalNotes || ""
  );
  const [relevantIssues, setRelevantIssues] = useState(
    patient.relevantIssues || ""
  );
  const [avoidTools, setAvoidTools] = useState(
    patient.avoidTools || ""
  );
  const [redFlags, setRedFlags] = useState(
    patient.redFlags || ""
  );
  const [protocolExample, setProtocolExample] = useState(
    patient.protocolExample || ""
  );

  const [finalLetter, setfinalLetter] = useState(
    patient.relevantIssues || ""
  );

  const [extractTextClass, setextractTextClass] = useState('extractText');
  const [extractTextClass3, setextractTextClass3] = useState('extractText3');





  

  useEffect(() => {
    if (patient && patient.patientFiles && patient.patientFiles.length > 0) {
      for (const patientFile of patient.patientFiles) {
        getUploadedFile(patient.id || -1, patientFile.fileName, signedInDoctor)
          .then(retrievedFile => {
            if (retrievedFile != undefined && retrievedFile.length == 2 && retrievedFile[0].length > 0)
              setFileList(prevFileList => [...prevFileList,
              {
                uid: generateCryptoUid(), status: 'done' as UploadFileStatus, name: patientFile.fileName,
                url: retrievedFile[0], type: retrievedFile[1],
                ...patientFile
              }])
          })
          .catch(err => console.error("Error while attempting to download img " + patientFile.fileName + " for patient " + (patient.id || -1), err))
      }
    }
  }, []);

  const handlePreview = async (file: UploadFile) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj as FileType);
    }

    setPreviewImage(file.url || (file.preview as string));
    setPreviewOpen(true);
  };

  const handleChange: UploadProps['onChange'] =
    ({ fileList: newFileList }) => {
      for (let f2 of fileList) {
        if (f2.fileId && f2.status && f2.status == "removed") {
          deleteFile(f2.fileId, f2.name, signedInDoctor, patient.id || -1);
        }
      }
      setFileList(newFileList);
      setPatient((prevPatient: Patient) => ({ ...prevPatient, patientFiles: newFileList }))
    }

  const handleExtractText = async (file: UploadFile) => {
    setextractTextClass("extractText2");
    if (!file.url) {
      return;
    }
    const response = await fetch(file.url);
    const blob = await response.blob();
    const text = await Tesseract.recognize(blob, 'ita', {
      logger: (m) => console.log(m),
    }).then(({ data: { text } }) => text);
    setExtractedText(text);
    setModalVisible(true);
    setextractTextClass("extractText");
  };

  

  const copyToClipboard = () => {
    navigator.clipboard.writeText(extractedText);
   setCopyOk(true);
  };

  const uploadButton = (
    <button style={{ border: 0, background: 'none' }} type="button">
      <PlusOutlined rev={undefined} />
      <div style={{ marginTop: 8 }}>Upload</div>
    </button>
  );

  const DocumentAi = () => {
    const [summary, setSummary] = useState<string>('');
    const [summary2, setSummary2] = useState<string>('');
    const [summary3, setSummary3] = useState<string>('');
    const [summary4, setSummary4] = useState<string>('');
    const [summary5, setSummary5] = useState<string>('');
    const textAreaReffer = useRef<HTMLTextAreaElement>(null);
    const textAreaRef = useRef<HTMLTextAreaElement>(null);
    const textAreaRef2 = useRef<HTMLTextAreaElement>(null);
    const textAreaRef3 = useRef<HTMLTextAreaElement>(null);
    const textAreaRef4 = useRef<HTMLTextAreaElement>(null);
    const textAreaRef5 = useRef<HTMLTextAreaElement>(null);

    

/*
    //Funzione aggiorna area di testo
    useEffect(() => {
      // Funzione da eseguire quando additionalNotes cambia
      if (textAreaRef.current) {
        console.log('additionalNotes è cambiato:', additionalNotes);
        // Esegui qualsiasi funzione desiderata sulla TextArea
      textAreaRef.current.value = additionalNotes;
      }
      if (textAreaRef2.current) {
        console.log('relevantIssues è cambiato:', relevantIssues);
       
      textAreaRef2.current.value = relevantIssues;
      }
      
      if (textAreaRef3.current) {
        console.log('avoidTools è cambiato:', avoidTools);
        
      textAreaRef3.current.value = avoidTools;
      }
      if (textAreaRef4.current) {
        console.log('redFlags è cambiato:', redFlags);
        
      textAreaRef4.current.value = redFlags;
      }
      if (textAreaRef5.current) {
        console.log('protocolExample è cambiato:', protocolExample);
        
      textAreaRef5.current.value = protocolExample;
      }
    }, [additionalNotes,relevantIssues,avoidTools,redFlags,protocolExample]); */


     //Funzione aggiorna area di testo
     useEffect(() => {
      // Funzione da eseguire quando additionalNotes cambia
      if (textAreaRef.current) {
        console.log('additionalNotes è cambiato:', additionalNotes);
        // Esegui qualsiasi funzione desiderata sulla TextArea
      textAreaRef.current.value = additionalNotes;
      }
    }, [additionalNotes]);

  //Funzione aggiorna area di testo2
  useEffect(() => {
    // Funzione da eseguire quando additionalNotes cambia
    if (textAreaRef2.current) {
      console.log('relevantIssues è cambiato:', relevantIssues);
      // Esegui qualsiasi funzione desiderata sulla TextArea
    textAreaRef2.current.value = relevantIssues;
    }
  }, [relevantIssues]);

   //Funzione aggiorna area di testo3
   useEffect(() => {
    // Funzione da eseguire quando additionalNotes cambia
    if (textAreaRef3.current) {
      console.log('avoidTools è cambiato:', avoidTools);
      // Esegui qualsiasi funzione desiderata sulla TextArea
    textAreaRef3.current.value = avoidTools;
    }
  }, [avoidTools]);

   //Funzione aggiorna area di testo4
   useEffect(() => {
    // Funzione da eseguire quando additionalNotes cambia
    if (textAreaRef4.current) {
      console.log('redFlags è cambiato:', redFlags);
      // Esegui qualsiasi funzione desiderata sulla TextArea
    textAreaRef4.current.value = redFlags;
    }
  }, [redFlags]);

   //Funzione aggiorna area di testo5
   useEffect(() => {
    // Funzione da eseguire quando additionalNotes cambia
    if (textAreaRef5.current) {
      console.log('protocolExample è cambiato:', protocolExample);
      // Esegui qualsiasi funzione desiderata sulla TextArea
    textAreaRef5.current.value = protocolExample;
    }
  }, [protocolExample]);

 
  

  const creationLetter = async () => {
      

    // crea Lettera
console.log('textAreaReffer:', textAreaReffer);
      const gptResponse = await fetch('https://api.openai.com/v1/chat/completions', { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${API_KEY}`,
        },
        body: JSON.stringify({
          model: 'gpt-3.5-turbo',
          messages: [
            {
              role: 'system',
              content: 'Sei un assistente specializzato nella creazione di lettere dettagliate e accurate basate esclusivamente sui dati forniti. La tua risposta deve essere chiara, sintetica e pertinente, includendo solo le informazioni fornite. NON devi in alcun modo menzionare costi, prezzi o aspetti economici.',
            },
            {
              role: 'user',
              content: ` ${textAreaReffer}`,
            },
          ],
          max_tokens: 600,
        }),
      });

        //END AND COMPLETE RESPONSES

        
//response 1
      const data = await gptResponse.json();
      const newSummaryX = data.choices[0].message.content.trim();
      console.log('newSummaryjhvbdh:', newSummaryX);

      setfinalLetter(newSummaryX); 
      setPatient({ ...patient, additionalNotes: newSummaryX });
    



    };



const handleAnalyzeDocuments = async () => {
      
    setextractTextClass3("extractText2");
      const documents = fileList.map(file => ({
        name: file.name,
        url: file.url
        //?.replace('http://local.host:3000/', 'https://www.physiocheck.app/app'),
      }));

      const extractedTexts = await Promise.all(
        documents.map(async (doc) => {
          if (!doc.url) {
            throw new Error(`URL is undefined for document: ${doc.name}`);
          }
          const response = await fetch(doc.url);
          const blob = await response.blob();
          const text = await Tesseract.recognize(blob, 'ita', {
            logger: (m) => console.log(m),
          }).then(({ data: { text } }) => text);
          return { name: doc.name, text };
          
        })
      );

      const combinedText = extractedTexts.map(doc => doc.text).join('\n');
     


    // riassunto della storia clinica

      const gptResponse = await fetch('https://api.openai.com/v1/chat/completions', { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${API_KEY}`,
        },
        body: JSON.stringify({
          model: 'gpt-3.5-turbo',
          messages: [
            {
              role: 'system',
              content: 'Sei un assistente specializzato nella creazione di storie cliniche dettagliate e accurate basate esclusivamente sui dati forniti. La tua risposta deve essere chiara, sintetica e pertinente, includendo solo informazioni mediche rilevanti. NON devi in alcun modo menzionare costi, prezzi o aspetti economici.',
            },
            {
              role: 'user',
              content: `Crea la storia clinica del paziente in ordine cronologico : ${combinedText}`,
            },
          ],
          max_tokens: 300,
        }),
      });

      // RESPONSE 2 PROBLEMATICHE RILEVANTI
      const gptResponse2 = await fetch('https://api.openai.com/v1/chat/completions', { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${API_KEY}`,
        },
        body: JSON.stringify({
          model: 'gpt-3.5-turbo',
          messages: [
            {
              role: 'system',
              content: 'Sei un assistente medico specializzato nell analisi delle storie cliniche. Il tuo compito è identificare le problematiche mediche rilevanti e fornirne un riassunto estremamente sintetico, mantenendo precisione e chiarezza',
            },
            {
              role: 'user',
              content: `Dimmi solo quali sono le problematiche rilevanti del paziente? ${combinedText}`,
            },
          ],
          max_tokens: 140,
        }),
      });

        // RESPONSE 3 CONTROINDICAZIONI
        const gptResponse3 = await fetch('https://api.openai.com/v1/chat/completions', { 
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${API_KEY}`,
          },
          body: JSON.stringify({
            model: 'gpt-3.5-turbo',
            messages: [
              {
                role: 'system',
                content: 'Sei un assistente medico fisioterapico specializzato nell analisi delle storie cliniche. Il tuo compito è identificare le controindicazioni legate alle terapie strumentali (es. Tecar terapia, TENS, EMTT, onde d’urto, ecc.) in base al caso clinico fornito. Rispondi in modo estremamente sintetico, elencando solo le terapie controindicate. Se non ci sono controindicazioni, rispondi semplicemente: Nessuna controindicazione strumentale.',
              },
              {
                role: 'user',
                content: `Dimmi solo quali sono le controindicazioni strumentali, ecco il testo: ${combinedText}`,
              },
            ],
            max_tokens: 140,
          }),
        });

          // RESPONSE 4 RED FLAGS
  /*  const gptResponse4 = await fetch('https://api.openai.com/v1/chat/completions', { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${API_KEY}`,
        },
        body: JSON.stringify({
          model: 'gpt-3.5-turbo',
          messages: [
            {
              role: 'system',
              content: 'Sei un assistente medico. Devi analizzare le storie cliniche e identificare le redflag e rispondere in modo altamente sintetico.',
            },
            {
              role: 'user',
              content: `Dimmi le redflag in modo estremamente sintetico possibili. Le RedFlags devono essere del tipo "ha pacemaker" "no elettromedicali"... non dare alcuna risposta. Ecco i referti: ${combinedText}`,
            },
          ],
          max_tokens: 140,
        }),
      });

*/
    


        // RESPONSE 5 ESEMPIO DI PROTOCOLLO
        const gptResponse5 = await fetch('https://api.openai.com/v1/chat/completions', { 
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${API_KEY}`,
          },
          body: JSON.stringify({
            model: 'gpt-3.5-turbo',
            messages: [
              {
                role: 'system',
                content: 'Sei un assistente fisioterapico specializzato nell analisi delle storie cliniche. Il tuo compito è elaborare un esempio di protocollo terapeutico basato sui dati forniti. La risposta deve essere estremamente sintetica, chiara e focalizzata sugli interventi essenziali.',
              },
              {
                role: 'user',
                content: `Creami un esempio di protocollo adatto al paziente? ${combinedText}`,
              },
            ],
            max_tokens: 140,
          }),
        });

      
        //END AND COMPLETE RESPONSES

        
//response 1
      const data = await gptResponse.json();
      const newSummary = data.choices[0].message.content.trim();
      console.log('newSummary:', newSummary);

      setSummary(newSummary);
      setAdditionalNotes(newSummary); 
      setPatient({ ...patient, additionalNotes: newSummary });
      
      setextractTextClass3("extractText");

      
//response 2
      
    const data2 = await gptResponse2.json();
    const newSummary2 = data2.choices[0].message.content.trim();
    console.log('newSummary2:', newSummary2);
    setRelevantIssues(newSummary2); 
    setPatient({ ...patient, relevantIssues: newSummary2 });
    setSummary2(newSummary2);
    

//response 3
      
    const data3 = await gptResponse3.json();
    const newSummary3 = data3.choices[0].message.content.trim();   
    console.log('newSummary3:', newSummary3);
    setAvoidTools(newSummary3); 
    setPatient({ ...patient, avoidTools: newSummary3 });
    setSummary3(newSummary3);


//response 4
      
const newSummary4 = "";   
console.log('newSummary4:', newSummary4);
setRedFlags(newSummary4); 
setPatient({ ...patient, redFlags: newSummary4 });
setSummary4(newSummary4);


//response 5
      
const data5 = await gptResponse5.json();
const newSummary5 = data5.choices[0].message.content.trim();   
console.log('newSummary5:', newSummary5);
setProtocolExample(newSummary5); 
setPatient({ ...patient, protocolExample: newSummary5 });
setSummary5(newSummary5);





    };
    
//STAMPARE DOCUMENTI

const handlePrint = () => {
  const printContent = `
    <div>
      <h3>Riassunto dei Documenti</h3>
      <p>${additionalNotes}</p>
      <h3>Problematiche rilevanti</h3>
      <p>${relevantIssues}</p>
      <h3>Controindicazioni Strumentali</h3>
      <p>${avoidTools}</p>
      <h3>Red Flags</h3>
      <p>${redFlags}</p>
      <h3>Esempio di Protocollo</h3>
      <p>${protocolExample}</p>
    </div>
  `;

  const printWindow = window.open('', '', 'height=600,width=800');
  if (printWindow) {
    printWindow.document.write('<html><head><title>Stampa</title></head><body>');
    printWindow.document.write(printContent);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  }
};

/* <Button style={{ backgroundColor: !analitycsVisible ? '#9fddc5' : '#a785a9' }} onClick={() => setAnalitycsVisible(true)}>Lettera Dimissioni</Button> */
  

    return (
      <>
<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
  <Button style={{ backgroundColor: analitycsVisible ? '#9fddc5' : '#a785a9' }} onClick={() => setAnalitycsVisible(false)}>Analisi Documenti AI</Button>
 
</div>
    

      { !analitycsVisible &&   
      <>
      <h2>ANALIZZA DOCUMENTI CON AI | <b>BETA</b></h2>
      <Button className={extractTextClass3} onClick={handleAnalyzeDocuments}>Analizza Documenti</Button>
        <h5 style={{ color: "red" }}>Importante! Effettuare una modifica nelle aree di testo al fine di confermare il controllo dell'Intelligenza Artificiale.</h5>
        
        <Row>
     
   
<Col span={24}>
         <h3>Riassunto dei Documenti</h3> 
         
            <Form.Item name="documentSummary" label="Riassunto dei Documenti">
              <TextArea
              
              ref={textAreaRef}
                 showCount
                //readOnly
                maxLength={5120}
            
               
              style={{ padding: 10, height: 280, borderRadius: 25 }}
                
              defaultValue={additionalNotes}
               value={additionalNotes} 
               
               onBlur={(e) => {
                const newValue = e.target.value;
                setPatient({ ...patient, additionalNotes: newValue });
                console.log("UPDATE: ", newValue);
              }}
              
                
              />
            </Form.Item>
           
          </Col>

          <Col span={24} style={{ textAlign: 'center', marginTop: '20px' }}>
          </Col>

      
          <Col span={24}>
          
          <h3>Problematiche rilevanti</h3> 
         
         <Form.Item name="documetRelevantIssues" label="Problematiche rilevanti">
           <TextArea
           ref={textAreaRef2}
              showCount
             //readOnly
             maxLength={512}
         
            
           style={{ padding: 10, height: 280, borderRadius: 25 }}
             
           defaultValue={relevantIssues}
            value={relevantIssues} 
            
            onBlur={(e) => {
             const newValue2 = e.target.value;
             setPatient({ ...patient, relevantIssues: newValue2 });
             console.log("UPDATE: ", newValue2);
           }}
           
             
           />
         </Form.Item>
         <Col span={24} style={{ textAlign: 'center', marginTop: '20px' }}>
          </Col>
       </Col>

       <Col span={24}>
         <h3>Controindicazioni Strumentali</h3> 
         
            <Form.Item name="documentAvoidTools" label="Controindicazioni Strumentali">
              <TextArea
              ref={textAreaRef3}
                 showCount
                //readOnly
                maxLength={512}
            
               
              style={{ padding: 10, height: 280, borderRadius: 25 }}
                
            defaultValue={avoidTools}
               value={avoidTools} 
               
               onBlur={(e) => {
                const newValue3 = e.target.value;
                setPatient({ ...patient, avoidTools: newValue3 });
                console.log("UPDATE: ", newValue3);
              }}
              
                
              />
            </Form.Item>
           
          </Col>
          <Col span={24} style={{ textAlign: 'center', marginTop: '20px' }}>
          </Col>

          <Col span={24}>
         <h3>Red Flags</h3> 
         
            <Form.Item name="documentRedFlags" label="Red Flags">
              <TextArea
              ref={textAreaRef4}
                 showCount
                //readOnly
                maxLength={512}
            
               
              style={{ padding: 10, height: 280, borderRadius: 25 }}
                
             defaultValue={redFlags}
               value={redFlags} 
               
               onBlur={(e) => {
                const newValue4 = e.target.value;
                setPatient({ ...patient, redFlags: newValue4 });
                console.log("UPDATE: ", newValue4);
              }}
              
                
              />
            </Form.Item>
           
          </Col>
          <Col span={24} style={{ textAlign: 'center', marginTop: '20px' }}>
          </Col>

          <Col span={24}>
         <h3>Esempio di Protocollo</h3> 
         
            <Form.Item name="documentProtocolExample" label="Esempio di Protocollo">
              <TextArea
              ref={textAreaRef5}
                 showCount
                //readOnly
                maxLength={512}
            
               
              style={{ padding: 10, height: 280, borderRadius: 25 }}
                
            defaultValue={protocolExample}
               value={protocolExample} 
               
               onBlur={(e) => {
                const newValue5 = e.target.value;
                setPatient({ ...patient, protocolExample: newValue5 });
                console.log("UPDATE: ", newValue5);
              }}
              
                
              />
            </Form.Item>
           
          </Col>
          <Col span={24} style={{ textAlign: 'center', marginTop: '20px' }}>
          </Col>
       
        </Row>
        <Button onClick={handlePrint}>Stampa</Button>
      </>
      }
       { analitycsVisible &&  
       <>

       <h2> GENERA LETTERA DI DIMISSIONI</h2>
         <h3>Istruzioni per la Lettera</h3> 
       <Row>
      <Col span={20}>
         
            <Form.Item name="letter-istruction" label="Istruzioni per la lettera">
              <TextArea
              
              ref={textAreaReffer}
                 showCount
                //readOnly
                maxLength={5120}
            
               
              style={{ padding: 10, height: 180, borderRadius: 25 }}
                
              
                
              />
            </Form.Item>
           
          </Col>
          <Col span={4}> 
            <button 
              style={{ 
              backgroundColor: '#9fddc5', 
              color: 'white', 
              fontWeight: 'bold', 
              padding: 25, 
              height: 180, 
              borderRadius: 25, 
              border: 'none', 
              marginTop: 5,
              transition: 'background-color 0.3s ease'
              }} 
              onClick={creationLetter}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#a785a9'}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#9fddc5'}
            >
              Crea Lettera
            </button>
          </Col>
          </Row>
          <Col span={24}>
         <h3>Lettera elaborata</h3> 
         
            <Form.Item name="letter" label="Istruzioni per la lettera">
              <TextArea
           
                 showCount
                //readOnly
                maxLength={5120}
            
               
              style={{ padding: 10, height: 350, borderRadius: 25 }}
                
               value={finalLetter} 
               defaultValue={finalLetter}
               
               onBlur={(e) => {
                const newValue = finalLetter;
                console.log("UPDATE: ", newValue);
              }}
              
                
              />
            </Form.Item>
           
          </Col>


       </>
       }  
      
      </>
    );
  };

  const uploadAction = async (uploadObjWrapper: any) => {
    return new Promise((resolve, reject) => {
      if (patient.id && uploadObjWrapper.file && uploadObjWrapper.file instanceof File) {
        const file: File = uploadObjWrapper.file;
        uploadFile(file, generateCryptoUid() + file.name, signedInDoctor, patient.id ? patient.id : -1)
          .then(res => {
            if (res.fileName && res.fileId > 0) {
              for (let fileobj of fileList) {
                if (fileobj.name && res.fileName.indexOf(fileobj.name) > 0) {
                  const newFileList = fileList.map((x) => (x.uid != fileobj.uid) ? x : {
                    ...x, status: 'done' as UploadFileStatus, fileId: res.fileId,
                    fileName: res.fileName, name: res.fileName, url: fileobj.url
                  })
                  setFileList(newFileList)
                  setPatient((prevPatient: Patient) => ({ ...prevPatient, patientFiles: newFileList }))
                }
              }
              resolve(res)
            }
            else
              reject(false)
          })
          .catch(err => console.log(err))
      }
      else
        reject(false)
    })
  }

/* <div className="redSelection">
      <h3>Analisi Documenti BETA</h3> <h5>Potrebbero esserci Bug o imperfezioni.</h5>
      </div> */


  return (
    <>
     
      <Upload
        customRequest={uploadAction}
        listType="picture-circle"
        fileList={fileList.filter(file => !file.name.includes("profile_image"))}
        onPreview={handlePreview}
        onChange={handleChange}
        accept="image/png, image/jpeg, image/heic, image/heif, image/gif, application/pdf"
        showUploadList={{ showDownloadIcon: true, showPreviewIcon: true, showRemoveIcon: true }}
        itemRender={(originNode, file) => {
          return (
            <>
           
        <div style={{
          width: 100  ,          // Larghezza fissa
          height: 100,         // Altezza fissa
          borderRadius: '50%', // Mantiene la forma circolare
         
     
        }}>
          
          {originNode} 
   
          
        </div>
           <div style={{  zoom: 0.9 , marginTop: "5px"}}>
            <Button className={extractTextClass} onClick={() => handleExtractText(file)}>Estrai Testo</Button>
            </div>
          </>
          )
        }}
      >
        {uploadButton}
        
      </Upload>
    
      
      {previewImage && (
        <>
      
        <Image
        style={{ marginBottom: '100px' }}        
          wrapperStyle={{ display: 'none' }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(''),
          }}
          src={previewImage}
        />
       
     
        </>
      )}   
      <Modal
        visible={modalVisible}
        onCancel={() => { setModalVisible(false); setCopyOk(false); }}
        
      footer={copyOk ? (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button key="copy" onClick={copyToClipboard}>
            
            <CheckOutlined rev={undefined} /> Copiato!
          </Button>
        </div>
      ) : (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button key="copy" onClick={copyToClipboard}>
          <CopyOutlined rev={undefined} /> Copia
          </Button>
        </div>
      )}
        
  
      >
        <TextArea value={extractedText} readOnly rows={15} />
      </Modal>
      <div style={{ marginBottom: '50px' }} />
      <DocumentAi />
    </>
  );
};

//bye leo
const EditPatientFormItemsRoad = ({
  patient,
  setPatient,
}: {
  patient: Patient;
  setPatient: Function;
}) => (
  <>
    <Row className="center-price">
      <div className="error center">
        <div className="error__icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            viewBox="0 0 24 24"
            height="24"
            fill="none"
          >
            <path
              fill="#393a37"
              d="m13 13h-2v-6h2zm0 4h-2v-2h2zm-1-15c-1.3132 0-2.61358.25866-3.82683.7612-1.21326.50255-2.31565 1.23915-3.24424 2.16773-1.87536 1.87537-2.92893 4.41891-2.92893 7.07107 0 2.6522 1.05357 5.1957 2.92893 7.0711.92859.9286 2.03098 1.6651 3.24424 2.1677 1.21325.5025 2.51363.7612 3.82683.7612 2.6522 0 5.1957-1.0536 7.0711-2.9289 1.8753-1.8754 2.9289-4.4189 2.9289-7.0711 0-1.3132-.2587-2.61358-.7612-3.82683-.5026-1.21326-1.2391-2.31565-2.1677-3.24424-.9286-.92858-2.031-1.66518-3.2443-2.16773-1.2132-.50254-2.5136-.7612-3.8268-.7612z"
            ></path>
          </svg>
        </div>
        <div className="error__title">Il protocollo non è in funzione.</div>
        <div className="error__close">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            viewBox="0 0 20 20"
            height="20"
          >
            <path
              fill="#393a37"
              d="m15.8333 5.34166-1.175-1.175-4.6583 4.65834-4.65833-4.65834-1.175 1.175 4.65833 4.65834-4.65833 4.6583 1.175 1.175 4.65833-4.6583 4.6583 4.6583 1.175-1.175-4.6583-4.6583z"
            ></path>
          </svg>
        </div>
      </div>
    </Row>
    <div className="offu-proto">
      <Row>
        <Col span={3}>
          <Form.Item label="Da rivisitare in Data" className="centered">
            <DatePicker locale={itIT.DatePicker} format={"DD/MM/YYYY"} />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={11}>
          <Form.Item name="roadc" label="Percorso Suggerito">
            <TextArea
              showCount
              maxLength={1024}
              style={{ height: 120 }}
              onChange={(e) =>
                setPatient({
                  ...patient,
                  roadc: e.target.value,
                })
              }
              count={undefined}
            />
          </Form.Item>
        </Col>
        <Col span={2}></Col>
        <Col span={11}>
          <Form.Item name="AVVERTENZE" label="Note aggiuntive">
            <TextArea
              showCount
              maxLength={1024}
              style={{ height: 120 }}
              onChange={(e) =>
                setPatient({ ...patient, attention: e.target.value })
              }
              count={undefined}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={11}>
          <Form.Item
            name="gkbox"
            label="Possiede GKBOX?"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Seleziona un'opzione"
              onChange={(selected: number) =>
                setPatient({ ...patient, gkbox: selected })
              }
            >
              <Option value={GkboxType.NOG}>Nessuno</Option>
              <Option value={GkboxType.ONE}>The One</Option>
              <Option value={GkboxType.EXC}>Exclusive</Option>
              <Option value={GkboxType.PRO}>Professional</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={2}></Col>
        <Col span={11}>
          <Form.Item
            name="policettivo"
            label="Possiede Policettivo?"
            rules={[{ required: true }]}
          >
            <Select
              placeholder="Seleziona un'opzione"
              onChange={(selected: number) =>
                setPatient({ ...patient, gkbox: selected })
              }
            >
              <Option value={PoliType.NOP}>Nessuno</Option>
              <Option value={PoliType.E}>Elicoidali</Option>
              <Option value={PoliType.EFA2}>Elicoidali FA2</Option>
              <Option value={PoliType.EA}>E-Antigravitario</Option>
              <Option value={PoliType.S}>Supinato</Option>
              <Option value={PoliType.P}>Pronato</Option>
            </Select>
          </Form.Item>
        </Col>
      </Row>
    </div>
  </>
);

// return selected form items tab
const EditPatientFormItems = ({
  selectedTab,
  patient,
  setPatient,
  signedInDoctor
}: {
  selectedTab: TABS;
  patient: Patient;
  setPatient: Function;
  signedInDoctor: SignedInDoctor;
}) => {
  switch (selectedTab) {
    case TABS.REQ:
      return (
        <EditPatientFormItemsRequired
          patient={patient}
          setPatient={setPatient} signedInDoctor={signedInDoctor}        />
      );

    case TABS.ADV:
      return (
        <EditPatientFormItemsAdvanced
          patient={patient}
          setPatient={setPatient}
        />
      );

    case TABS.MED:
      return (
        <EditPatientFormItemsMedical
          patient={patient}
          setPatient={setPatient}
        />
      );

    case TABS.FILE:
      return (
        <EditPatientFormItemsDocument
          patient={patient}
          setPatient={setPatient}
          signedInDoctor={signedInDoctor}
        />
      );
    case TABS.ROD:
      return (
        <EditPatientFormItemsRoad patient={patient} setPatient={setPatient} />
      );

    default:
      return <></>;
  }
};

export default EditPatientFormItems;
function setEditError(ALMSG_INTERNAL_ERR: any): any {
  throw new Error("Function not implemented.");
}

function setEditSuccess(arg0: string) {
  throw new Error("Function not implemented.");
}

